/* tslint:disable */
/* eslint-disable */
/**
 * AdServer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { SlotFromJSON, SlotToJSON, } from '../models/index';
/**
    * Converts a number to a padded string
    * @param num The number to stringify
    * @param size Number of total digits
    */
function pad(num, size) {
    let negative = num < 0;
    if (negative) {
        num *= -1;
    }
    let numString = num.toString();
    while (numString.length < size)
        numString = "0" + numString;
    return (negative ? "-" : "") + numString;
}
/**
    * Returns a date in the RFC3339 format, e.g.: 2016-01-19T15:21:32.59+02:00
    * @param dateTime
    */
export function toRFC3339(dateTime) {
    let rfcWithoutTimeoffset = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1, 2)}-${pad(dateTime.getDate(), 2)}T${pad(dateTime.getHours(), 2)}:${pad(dateTime.getMinutes(), 2)}:${pad(dateTime.getSeconds(), 2)}${dateTime.getMilliseconds() != 0 ? "." + pad(dateTime.getMilliseconds(), 3) : ""}`;
    let timeOffsetString;
    let to = dateTime.getTimezoneOffset() * -1;
    let toh = Math.floor(to / 60);
    let tom = to % 60;
    if (tom < 0) {
        tom *= -1;
    }
    timeOffsetString = pad(toh, 2) + ":" + pad(tom, 2);
    return rfcWithoutTimeoffset + (toh > 0 ? "+" : "") + timeOffsetString;
}
/**
 *
 */
export class SlotApi extends runtime.BaseAPI {
    /**
     * Updates a slot, cannot edit owner, dimensions, games reference.
     */
    async slotSlotIdPutRaw(requestParameters, initOverrides) {
        if (requestParameters['slotId'] == null) {
            throw new runtime.RequiredError('slotId', 'Required parameter "slotId" was null or undefined when calling slotSlotIdPut().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/slot/{slotId}`.replace(`{${"slotId"}}`, encodeURIComponent(String(requestParameters['slotId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SlotToJSON(requestParameters['slot']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SlotFromJSON(jsonValue));
    }
    /**
     * Updates a slot, cannot edit owner, dimensions, games reference.
     */
    async slotSlotIdPut(requestParameters, initOverrides) {
        const response = await this.slotSlotIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Retrieves the slots for the give game id
     */
    async slotsGameGameIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters['gameId'] == null) {
            throw new runtime.RequiredError('gameId', 'Required parameter "gameId" was null or undefined when calling slotsGameGameIdGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/slots/game/{gameId}`.replace(`{${"gameId"}}`, encodeURIComponent(String(requestParameters['gameId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SlotFromJSON));
    }
    /**
     * Retrieves the slots for the give game id
     */
    async slotsGameGameIdGet(requestParameters, initOverrides) {
        const response = await this.slotsGameGameIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all slots
     */
    async slotsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/slots`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SlotFromJSON));
    }
    /**
     * Get all slots
     */
    async slotsGet(initOverrides) {
        const response = await this.slotsGetRaw(initOverrides);
        return await response.value();
    }
}
